module.exports = __webpack_public_path__ + "static/bordr-logo-social-d151bd72168f69c411c6deedd2b4a277.jpg";